module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form-wizard', {
    ref: "formWizard",
    attrs: {
      "step-size": _vm.stepSize,
      "color": "#D6E13A"
    },
    on: {
      "on-change": _vm.handleChange,
      "on-complete": _vm.sendOrder
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function(slotProps) {
        return [(slotProps.activeTabIndex === 0) ? _c('div', {
          staticClass: "order-result bt-0"
        }, [_c('div', {
          staticClass: "order-result-block-2 m-0"
        }, [_c('div', {
          staticClass: "order-result-block-2__col order-result-block-2__col-1"
        }, [_c('div', {
          staticClass: "order-cost-summary"
        }, [_c('div', {
          staticClass: "order-cost-summary__label"
        }, [_vm._v("\n                                Preis\n                            ")]), _vm._v(" "), _c('div', {
          staticClass: "order-cost-summary__price-container"
        }, [_c('div', {
          staticClass: "order-cost-summary__price-total"
        }, [_vm._v("\n                                    Total pro " + _vm._s(_vm.mode === 'private' ? 'Lieferung' : 'Woche') + ": "), _c('br'), _vm._v(" " + _vm._s(_vm._f("formatPrice")(_vm._f("round")((_vm.mode === 'private' ? _vm.total('subscription') : _vm.totalPerWeek('subscription'))))) + "\n                                ")]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.mode === 'business'),
            expression: "mode === 'business'"
          }],
          staticClass: "order-cost-summary__price-details"
        }, [_vm._v("\n                                    Total pro Mitarbeiter / Woche: " + _vm._s(_vm._f("formatPrice")(_vm._f("round")(_vm.totalPerPersonPerWeek('subscription')))) + "\n                                ")]), _vm._v(" "), _c('div', {
          staticClass: "order-cost-summary__price-details"
        }, [_vm._v("\n                                    (inkl. Lieferung / exkl. MwSt. 2.6 %)\n                                ")])])])]), _vm._v(" "), _c('div', {
          staticClass: "order-result-block-2__col order-result-block-2__col-2 inverted-colors"
        }, [_c('a', {
          staticClass: "order-result-block-2__link-next",
          attrs: {
            "href": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.nextTab(slotProps)
            },
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.nextTab(slotProps)
            }
          }
        }, [_c('span', {
          staticClass: "order-result-block-2__link-next-text"
        }, [_vm._v("\n                                Weiter zur Adresse\n                            ")])])])])]) : _vm._e(), _vm._v(" "), (slotProps.activeTabIndex === 1) ? _c('div', {
          staticClass: "order-address-form__btn-container"
        }, [_c('a', {
          staticClass: "order-address-form__link--before m-0",
          attrs: {
            "href": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.prevTabAddress(slotProps.prevTab)
            },
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.prevTabAddress(slotProps.prevTab)
            }
          }
        }, [_vm._v("\n                    Zurück zum Abo\n                ")]), _vm._v(" "), _c('div', {
          staticClass: "order-address-form__link--next m-0",
          on: {
            "click": function($event) {
              return _vm.nextTabAddress(slotProps.nextTab)
            },
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.nextTabAddress(slotProps.nextTab)
            }
          }
        }, [_vm._v("\n                    Weiter zur Übersicht\n                ")])]) : _vm._e(), _vm._v(" "), (slotProps.activeTabIndex === 2) ? _c('div', {
          staticClass: "order-summary__btn-container"
        }, [_c('a', {
          staticClass: "order-address-form__link--before m-0",
          attrs: {
            "href": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.prevTab(slotProps)
            },
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.prevTab(slotProps)
            }
          }
        }, [_vm._v("\n                    Zurück zur Adresse\n                ")]), _vm._v(" "), _c('a', {
          staticClass: "order-address-form__link--next m-0",
          attrs: {
            "href": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.nextTab(slotProps)
            },
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.nextTab(slotProps)
            }
          }
        }, [_vm._v("\n                    Abo bestellen\n                ")])]) : _vm._e()]
      }
    }])
  }, [_c('tab-content', {
    attrs: {
      "title": "Abo"
    }
  }, [_c('order', {
    ref: "orderStep"
  })], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Adresse"
    }
  }, [_c('Address', {
    ref: "addressForm"
  })], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Übersicht"
    }
  }, [(_vm.subscriptionType) ? _c('OrderSummary') : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f712272","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Wizard.vue
// module id = 865
// module chunks = 0